import { render } from "./Auth.vue?vue&type=template&id=21165028"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=21165028&lang=css"

import exportComponent from "/codebuild/output/src1941686567/src/amplify-vue-poc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__